import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let app = useDataValue({
    context: 'app',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!app || !app.properties) {
      return {
        steps: [],
        current_index: 0,
      }
    }

    return {
      steps: app.properties.map(item => {
        let companyValue = app.company.properties?.[item.key]
        let value =
          item.type === 'SECURE_STRING' && companyValue
            ? `ENCRYPTED:${companyValue}`
            : companyValue ?? item.defaultValue ?? null

        return {
          ...item,
          id: item.key,
          value,
        }
      }),
      current_index: 0,
    }
  }, []) // eslint-disable-line
  // ignore changes to properties
}
